import React from 'react';
import { Modal } from 'antd';

const PrintInstructions = ({ visible, setVisible, printStepsImage }) => {
  return (
    <Modal
      title="打印操作方法"
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      width={800}
    >
      <div style={{ padding: '20px' }}>
        <h3>由于不限制操作系统以及不用安装任何插件，使用Firefox浏览器自带打印功能，请按3个步骤设置，即可连续打印：</h3>
        <h5>1️⃣ 打开Firefox浏览器，进入about:config，如提醒点击继续    2️⃣ 搜索print.always_print_silent，默认为false    3️⃣点击切换按钮打开它</h5>
        <h4>现在就可以连续打印了</h4>
        <div style={{ marginTop: '20px' }}>
          <img 
            src={printStepsImage} 
            alt="Print Setup Steps"
            style={{
              width: '100%',
              objectFit: 'contain',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              borderRadius: '4px'
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default PrintInstructions;
